<template>
  <div>
    <DataTable
      v-model:filters="filters"
      :value="items"
      :loading="loading"
      :rows="10"
      lazy
      row-hover
      paginator
      :totalRecords="total"
      :rowsPerPageOptions="[10, 25, 50]"
      dataKey="id"
      filterDisplay="row"
      class="p-datatable-sm"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Memuat {first} dari {last} data dari total {totalRecords}"
      scrollable
      @page="onPage($event)"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <Column field="kode" header="Kode">
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column field="nama" header="Nama">
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column field="head_id" header="Head Account">
        <template #body="{ data }">
          {{ data.head }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            :options="listHeadAccount"
            optionValue="id"
            optionLabel="nama"
            class="p-column-filter text-right"
            @change="
              () => {
                this.getKelompokAccount(filterModel.value)
                filterCallback()
              }
            "
          />
        </template>
      </Column>
      <Column field="group_id" header="Kelompok Account">
        <template #body="{ data }">
          {{ data.group }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            :options="listKelompokAccountFiltered"
            optionValue="id"
            optionLabel="nama"
            class="p-column-filter text-right"
            @change="
              () => {
                this.getKelompokAccount(filterModel.value)
                filterCallback()
              }
            "
          />
        </template>
      </Column>
      <Column field="sgroup_id" header="Sub Kelompok Account">
        <template #body="{ data }">
          {{ data.sgroup }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            :options="listSubKelompokAccountFiltered"
            optionValue="id"
            optionLabel="nama"
            class="p-column-filter text-right"
            @change="filterCallback()"
          />
        </template>
      </Column>
      <Column style="flex-grow: 1; justify-content: flex-end">
        <template #body="{ data }">
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text"
            @click="$emit('edit', data)"
          />
          <Button
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-danger p-button-text"
            @click="$emit('delete', data)"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
// import CalendarFilter from '@/components/CalendarFilter'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    gridOptions: {
      type: Object,
      default() {
        return {}
      },
    },
    listHeadAccount: {
      type: Array,
      default() {
        return []
      },
    },
    listKelompokAccount: {
      type: Array,
      default() {
        return []
      },
    },
    listSubKelompokAccount: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: {},
  data() {
    return {
      options: this.gridOptions,
      filters: {
        kode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nama: { value: null, matchMode: FilterMatchMode.CONTAINS },
        head_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        group_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sgroup_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      listKelompokAccountFiltered: [],
      listSubKelompokAccountFiltered: [],
    }
  },
  updated() {
    this.getKelompokAccount(this.filters.head_id.value)
    this.getSubKelompokAccount(this.filters.group_id.value)
  },
  methods: {
    onPage(e) {
      e.page = e.page + 1
      e.sortField = this.options.sortField
      e.sortOrder = this.options.sortOrder
      this.options = e
      this.options.filters = this.filters
      this.loadData()
    },
    onSort(e) {
      this.options = e
      this.loadData()
    },
    onFilter() {
      this.options.page = 1
      this.options.filters = this.filters
      this.loadData()
    },
    loadData() {
      this.$emit('request', this.options)
    },
    getKelompokAccount(id) {
      if (id !== undefined && id !== null) {
        this.listKelompokAccountFiltered = this.listKelompokAccount.filter(
          (kelompokAccount) => kelompokAccount.parent_id == id
        )
      } else {
        this.listKelompokAccountFiltered = this.listKelompokAccount
      }
    },
    getSubKelompokAccount(id) {
      if (id !== undefined && id !== null) {
        this.listSubKelompokAccountFiltered =
          this.listSubKelompokAccount.filter(
            (subKelompokAccount) => subKelompokAccount.parent_id == id
          )
      } else {
        this.listSubKelompokAccountFiltered = this.listSubKelompokAccount
      }
    },
  },
}
</script>
